import { ApiResponse, GlobalStore, GridStore } from "@roc/feature-app-core";
import { LeadsDashboardService } from "../services/leadsDashboardService";
import { LeadsDashboardStore } from "./leadsDashboardStore";

const PAGE_SIZE = 200;
export class UserMetricsDashboardGridStore extends GridStore {
  private globalStore: GlobalStore;
  private leadsDashboardStore: LeadsDashboardStore;
  private leadsDashboardService: LeadsDashboardService;

  constructor(globalStore: GlobalStore, leadsDashboardStore) {
    super(() => this.fetchRows(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.leadsDashboardStore = leadsDashboardStore;
    this.leadsDashboardService = new LeadsDashboardService();
  }

  fetchRows = async () => {
    const { currentDashboardId } = this.leadsDashboardStore;
    const response: ApiResponse = await this.leadsDashboardService.getUserMetricsByListId(
      currentDashboardId,
      this.gridData.meta.pageNumber,
      this.gridData.meta.pageSize,
      this.gridData.meta.sortBy,
      this.gridData.meta.sortDir,
      this.gridData.meta.filters,
      this.gridData.meta.dropdownFilters,
      this.leadsDashboardStore.businessUnit
    );
    return response;
  }
}